const GoogleOAuthRedirectShow = () => import('@/modules/integrations/views/OAuthRedirectShow')
const MetaOAuthRedirectShow = () => import('@/modules/integrations/views/OAuthRedirectShow')
const TikTokOAuthRedirectShow = () => import('@/modules/integrations/views/OAuthRedirectShow')

export default [
  {
    path: '/google-oauth-redirect',
    name: 'integrations.google-oauth-redirect.show',
    component: GoogleOAuthRedirectShow,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/meta-oauth-redirect',
    name: 'integrations.meta-oauth-redirect.show',
    component: MetaOAuthRedirectShow,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/tiktok-oauth-redirect',
    name: 'integrations.tiktok-oauth-redirect.show',
    component: TikTokOAuthRedirectShow,
    meta: { requiresAuthentication: true }
  }
]
